import React from "react";
import { useEffect, useState } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import FiltroMultiple from "../../Postventa/Dashboard/Modales/FiltroMultiple";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";

export const AnaliticaTable = ({ data, onOrigenChange }) => {
  const [origenActual, setOrigenActual] = useState(null);

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setOrigenActual(data[0]?.origen ?? null);
    } else {
      setOrigenActual(null);
    }
  }, [data]);

  const mostrarTasa = origenActual === "Anticipos";
  const mostrarRelacionada = origenActual === "Anticipos";

  const [ordenFecha, setOrdenFecha] = useState(null);
  const [ordenRelacionada, setOrdenRelacionada] = useState(null);
  const [ordenFechaAplicacion, setOrdenFechaAplicacion] = useState(null);
  const [ordenFechaCancelacion, setOrdenFechaCancelacion] = useState(null);

  const resetOrdenamientos = (...setters) => setters.forEach((s) => s(null));

  const toggleOrdenFecha = () => {
    resetOrdenamientos(setOrdenRelacionada, setOrdenFechaAplicacion, setOrdenFechaCancelacion);
    setOrdenFecha((prev) => (prev === null ? "asc" : prev === "asc" ? "desc" : null));
  };

  const toggleOrdenRelacionada = () => {
    resetOrdenamientos(setOrdenFecha, setOrdenFechaAplicacion, setOrdenFechaCancelacion);
    setOrdenRelacionada((prev) => (prev === null ? "asc" : prev === "asc" ? "desc" : null));
  };

  const toggleOrdenFechaAplicacion = () => {
    resetOrdenamientos(setOrdenFecha, setOrdenRelacionada, setOrdenFechaCancelacion);
    setOrdenFechaAplicacion((prev) => (prev === null ? "asc" : prev === "asc" ? "desc" : null));
  };

  const toggleOrdenFechaCancelacion = () => {
    resetOrdenamientos(setOrdenFecha, setOrdenRelacionada, setOrdenFechaAplicacion);
    setOrdenFechaCancelacion((prev) => (prev === null ? "asc" : prev === "asc" ? "desc" : null));
  };

  const [options, setOptions] = useState({
    origen: [],
    sucursal: [],
    departamento: [],
    cuenta: [],
    main: [],
    fecha: [],
    serie: [],
    estatus: [],
    comprobante: [],
    condicionPago: [],
    usuario: [],
    equip: [],
    tasa: [],
    relacion: [],
    ref: []
  });
  const [filtros, setFiltros] = useState({
    origen: [],
    sucursal: [],
    departamento: [],
    cuenta: [],
    main: [],
    fecha: [],
    serie: [],
    estatus: [],
    comprobante: [],
    condicionPago: [],
    usuario: [],
    equip: [],
    tasa: [],
    relacion: [],
    ref: []
  });
  const [prioridadFiltros, setPrioridadFiltros] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);

  const [filtrosTemp, setFiltrosTemp] = useState({
    origen: [],
    sucursal: [],
    departamento: [],
    cuenta: [],
    main: [],
    fecha: [],
    serie: [],
    estatus: [],
    comprobante: [],
    condicionPago: [],
    usuario: [],
    equip: [],
    tasa: [],
    relacion: [],
    ref: []
  });

  const [mostrarFiltro, setMostrarFiltro] = useState({
    origen: { open: false },
    sucursal: { open: false },
    departamento: { open: false },
    cuenta: { open: false },
    main: { open: false },
    fecha: { open: false },
    serie: { open: false },
    estatus: { open: false },
    comprobante: { open: false },
    condicionPago: { open: false },
    usuario: { open: false },
    equip: { open: false },
    tasa: { open: false },
    relacion: { open: false },
    ref: { open: false }
  });

  const actualizarPrioridad = (filtro) => {
    setPrioridadFiltros((prev) => {
      const index = prev.indexOf(filtro);

      let nuevasPrioridades;

      // nuevo filtro → se agrega
      if (index === -1) {
        nuevasPrioridades = [...prev, filtro];
      }
      // filtro existente → se cortan los posteriores
      else {
        nuevasPrioridades = prev.slice(0, index + 1);
      }

      // 🔥 LIMPIAR filtros que perdieron prioridad
      setFiltrosTemp((prevTemp) => {
        const limpio = { ...prevTemp };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      // 🔥 LIMPIAR filtros aplicados también
      setFiltros((prevFiltros) => {
        const limpio = { ...prevFiltros };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      return nuevasPrioridades;
    });
  };

  const aplicarFiltros = (data, filtros, _, filtrosPermitidos = []) => {
    let resultado = [...data];

    filtrosPermitidos.forEach((filtro) => {
      if (filtro === "origen" && filtros.origen.length > 0) {
        resultado = resultado.filter((i) => filtros.origen.includes(i.origen));
      }

      if (filtro === "sucursal" && filtros.sucursal.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.sucursal.includes(i.sucursal),
        );
      }

      if (filtro === "departamento" && filtros.departamento.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.departamento.includes(i.departamento),
        );
      }

      if (filtro === "cuenta" && filtros.cuenta.length > 0) {
        resultado = resultado.filter((i) => filtros.cuenta.includes(i.cuenta));
      }

      if (filtro === "main" && filtros.main.length > 0) {
        resultado = resultado.filter((i) => filtros.main.includes(i.v_gl_main));
      }

      if (filtro === "fecha" && filtros.fecha.length > 0) {
        resultado = resultado.filter((i) => filtros.fecha.includes(i.v_fecha));
      }

      if (filtro === "serie" && filtros.serie.length > 0) {
        resultado = resultado.filter((i) => filtros.serie.includes(i.serie));
      }

      if (filtro === "estatus" && filtros.estatus.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.estatus.includes(i.estatus),
        );
      }

      if (filtro === "comprobante" && filtros.comprobante.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.comprobante.includes(i.tipoComprobante),
        );
      }

      if (filtro === "condicionPago" && filtros.condicionPago.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.condicionPago.includes(i.condicionPago),
        );
      }

      if (filtro === "usuario" && filtros.usuario.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.usuario.includes(i.v_usuario),
        );
      }

      if (filtro === "equip" && filtros.equip.length > 0) {
        resultado = resultado.filter((i) => filtros.equip.includes(i.equip));
      }

      if (filtro === "tasa" && filtros.tasa.length > 0) {
        resultado = resultado.filter((i) => filtros.tasa.includes(i.tasa));
      }

      if (filtro === "relacion" && filtros.relacion.length > 0) {
        resultado = resultado.filter((i) => {
          const tieneRelacion = i.v_relacion !== null && i.v_relacion !== undefined && i.v_relacion !== "";
          if (filtros.relacion.includes("Relacionado") && filtros.relacion.includes("No relacionado")) return true;
          if (filtros.relacion.includes("Relacionado")) return tieneRelacion;
          if (filtros.relacion.includes("No relacionado")) return !tieneRelacion;
          return true;
        });
      }

      if (filtro === "ref" && filtros.ref.length > 0) {
        resultado = resultado.filter((i) => filtros.ref.includes(i.v_ref));
      }
    });

    return resultado;
  };

  useEffect(() => {
    if (!Array.isArray(data)) return;

    let result = [...data];

    prioridadFiltros.forEach((filtro) => {
      switch (filtro) {
        case "origen":
          if (filtros.origen.length > 0) {
            result = result?.filter((i) => filtros.origen.includes(i.origen));
          }
          break;

        case "sucursal":
          if (filtros.sucursal.length > 0) {
            result = result?.filter((i) =>
              filtros.sucursal.includes(i.sucursal),
            );
          }
          break;

        case "departamento":
          if (filtros.departamento.length > 0) {
            result = result?.filter((i) =>
              filtros.departamento.includes(i.departamento),
            );
          }
          break;

        case "cuenta":
          if (filtros.cuenta.length > 0) {
            result = result?.filter((i) => filtros.cuenta.includes(i.cuenta));
          }
          break;

        case "main":
          if (filtros.main.length > 0) {
            result = result?.filter((i) => filtros.main.includes(i.v_gl_main));
          }
          break;

        case "fecha":
          if (filtros.fecha.length > 0) {
            result = result?.filter((i) => filtros.fecha.includes(i.v_fecha));
          }
          break;

        case "serie":
          if (filtros.serie.length > 0) {
            result = result?.filter((i) => filtros.serie.includes(i.serie));
          }
          break;

        case "estatus":
          if (filtros.estatus.length > 0) {
            result = result?.filter((i) => filtros.estatus.includes(i.estatus));
          }
          break;

        case "comprobante":
          if (filtros.comprobante.length > 0) {
            result = result?.filter((i) =>
              filtros.comprobante.includes(i.tipoComprobante),
            );
          }
          break;

        case "condicionPago":
          if (filtros.condicionPago.length > 0) {
            result = result?.filter((i) =>
              filtros.condicionPago.includes(i.condicionPago),
            );
          }
          break;

        case "usuario":
          if (filtros.usuario.length > 0) {
            result = result?.filter((i) =>
              filtros.usuario.includes(i.v_usuario),
            );
          }
          break;

        case "equip":
          if (filtros.equip.length > 0) {
            result = result?.filter((i) => filtros.equip.includes(i.equip));
          }
          break;

        case "tasa":
          if (filtros.tasa.length > 0) {
            result = result?.filter((i) => filtros.tasa.includes(i.tasa));
          }
          break;

        case "relacion":
          if (filtros.relacion.length > 0) {
            result = result?.filter((i) => {
              const tieneRelacion = i.v_relacion !== null && i.v_relacion !== undefined && i.v_relacion !== "";
              if (filtros.relacion.includes("Relacionado") && filtros.relacion.includes("No relacionado")) return true;
              if (filtros.relacion.includes("Relacionado")) return tieneRelacion;
              if (filtros.relacion.includes("No relacionado")) return !tieneRelacion;
              return true;
            });
          }
          break;

        case "ref":
          if (filtros.ref.length > 0) {
            result = result?.filter((i) => filtros.ref.includes(i.v_ref));
          }
          break;

        default:
          break;
      }
    });

    if (ordenFecha) {
      result = [...result].sort((a, b) => {
        const fechaA = new Date(a.v_fecha).getTime();
        const fechaB = new Date(b.v_fecha).getTime();
        return ordenFecha === "asc" ? fechaA - fechaB : fechaB - fechaA;
      });
    }

    if (ordenRelacionada) {
      result = [...result].sort((a, b) => {
        const valA = (a.v_relacion ?? "").toString();
        const valB = (b.v_relacion ?? "").toString();
        return ordenRelacionada === "asc"
          ? valA.localeCompare(valB, "es", { numeric: true, sensitivity: "base" })
          : valB.localeCompare(valA, "es", { numeric: true, sensitivity: "base" });
      });
    }

    if (ordenFechaAplicacion) {
      result = [...result].sort((a, b) => {
        const fechaA = a.v_fecha_relacion ? new Date(a.v_fecha_relacion).getTime() : 0;
        const fechaB = b.v_fecha_relacion ? new Date(b.v_fecha_relacion).getTime() : 0;
        return ordenFechaAplicacion === "asc" ? fechaA - fechaB : fechaB - fechaA;
      });
    }

    if (ordenFechaCancelacion) {
      result = [...result].sort((a, b) => {
        const fechaA = a.fechacancelacion ? new Date(a.fechacancelacion).getTime() : 0;
        const fechaB = b.fechacancelacion ? new Date(b.fechacancelacion).getTime() : 0;
        return ordenFechaCancelacion === "asc" ? fechaA - fechaB : fechaB - fechaA;
      });
    }

    setDatosFiltrados(result);
  }, [data, filtros, prioridadFiltros, ordenFecha, ordenRelacionada, ordenFechaAplicacion, ordenFechaCancelacion]);

  useEffect(() => {
    if (!Array.isArray(data)) return;

    const getBaseData = (filtro) => {
      const index = prioridadFiltros.indexOf(filtro);

      // Si el filtro NO ha sido usado aún → usar data filtrada actual
      if (index === -1) {
        return aplicarFiltros(data, filtros, null, prioridadFiltros);
      }

      // Si es el primero → data completa
      if (index === 0) {
        return data;
      }

      // Solo aplicar filtros con MAYOR prioridad
      const filtrosPrevios = prioridadFiltros.slice(0, index);

      return aplicarFiltros(data, filtros, null, filtrosPrevios);
    };

    // ORIGEN
    const origenOptions = [
      ...new Set(getBaseData("origen").map((i) => i.origen)),
    ].map((v) => ({ value: v, label: v }));

    const sucursalOptions = [
      ...new Set(getBaseData("sucursal").map((i) => i.sucursal)),
    ].map((v) => ({ value: v, label: v }));

    const departamentoOptions = [
      ...new Set(getBaseData("departamento").map((i) => i.departamento)),
    ].map((v) => ({ value: v, label: v }));

    const cuentaOptions = [
      ...new Set(getBaseData("cuenta").map((i) => i.cuenta)),
    ].map((v) => ({ value: v, label: v }));

    const mainOptions = [
      ...new Set(getBaseData("main").map((i) => i.v_gl_main)),
    ].map((v) => ({ value: v, label: v }));

    const fechaOptions = [
      ...new Set(getBaseData("fecha").map((i) => i.v_fecha)),
    ].map((v) => ({ value: v, label: v }));

    const serieOptions = [
      ...new Set(getBaseData("serie").map((i) => i.serie)),
    ].map((v) => ({ value: v, label: v }));

    const estatusOptions = [
      ...new Set(getBaseData("estatus").map((i) => i.estatus)),
    ].map((v) => ({ value: v, label: v }));

    const comprobanteOptions = [
      ...new Set(getBaseData("comprobante").map((i) => i.tipoComprobante)),
    ].map((v) => ({ value: v, label: v }));

    const condicionPagoOptions = [
      ...new Set(getBaseData("condicionPago").map((i) => i.condicionPago)),
    ].map((v) => ({ value: v, label: v }));

    const usuarioOptions = [
      ...new Set(getBaseData("usuario").map((i) => i.v_usuario)),
    ].map((v) => ({ value: v, label: v }));

    const equipOptions = [...new Set(getBaseData("equip").map((i) => i.equip))]
      .sort((a, b) => a?.localeCompare(b))
      .map((v) => ({ value: v, label: v }));

    const tasaOptions = [
      ...new Set(getBaseData("tasa").map((i) => i.tasa)),
    ].map((v) => ({ value: v, label: v }));

    const refOptions = [
      ...new Set(getBaseData("ref").map((i) => i.v_ref)),
    ].map((v) => ({ value: v, label: v }));

    setOptions({
      origen: origenOptions,
      sucursal: sucursalOptions,
      departamento: departamentoOptions,
      cuenta: cuentaOptions,
      main: mainOptions,
      fecha: fechaOptions,
      serie: serieOptions,
      estatus: estatusOptions,
      comprobante: comprobanteOptions,
      condicionPago: condicionPagoOptions,
      usuario: usuarioOptions,
      equip: equipOptions,
      tasa: tasaOptions,
      relacion: [
        { value: "Relacionado",    label: "Relacionado" },
        { value: "No relacionado", label: "No relacionado" },
      ],
      ref: refOptions
    });
  }, [data, filtros, prioridadFiltros]);

  const sumaCargos = (datosFiltrados.length > 0 ? datosFiltrados : data).reduce(
    (acumulador, objetoActual) => {
      return acumulador + objetoActual.v_cargos;
    },
    0,
  );

  const sumaAbonos = (datosFiltrados.length > 0 ? datosFiltrados : data).reduce(
    (acumulador, objetoActual) => {
      return acumulador + objetoActual.v_abonos;
    },
    0,
  );
  const origenTexto =
    filtros.origen.length > 0
      ? filtros.origen.join(", ")
      : options.origen.map((o) => o.value).join(", ");

  useEffect(() => {
    if (!onOrigenChange) return;

    const datos = datosFiltrados.length > 0 ? datosFiltrados : data;

    const cargos = datos.reduce((acc, r) => acc + (Number(r.v_cargos) || 0), 0);
    const abonos = datos.reduce((acc, r) => acc + (Number(r.v_abonos) || 0), 0);
    const diferencia = abonos - cargos;
    const registros = datos.length;

    onOrigenChange({
      origen: origenTexto,
      cargos,
      abonos,
      diferencia,
      registros,
    });
  }, [origenTexto, datosFiltrados, data]);
  return (
    <table className="analitica">
      <thead>
        <tr>
          {/* <th>
            <FiltroMultiple
              label="Origen"
              field="origen"
              options={options.origen}
              filtros={filtros}
              setFiltros={setFiltros}
              filtrosTemp={filtrosTemp}
              setFiltrosTemp={setFiltrosTemp}
              mostrarFiltro={mostrarFiltro}
              setMostrarFiltro={setMostrarFiltro}
              actualizarPrioridad={actualizarPrioridad}
              setPrioridadFiltros={setPrioridadFiltros}
            />
          </th> */}
          <th>
            {/* <div className="borde-izq"> */}
            <FiltroMultiple
              label="Sucursal"
              field="sucursal"
              options={options.sucursal}
              filtros={filtros}
              setFiltros={setFiltros}
              filtrosTemp={filtrosTemp}
              setFiltrosTemp={setFiltrosTemp}
              mostrarFiltro={mostrarFiltro}
              setMostrarFiltro={setMostrarFiltro}
              actualizarPrioridad={actualizarPrioridad}
              setPrioridadFiltros={setPrioridadFiltros}
            />
            {/* </div> */}
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Departamento"
                field="departamento"
                options={options.departamento}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Cuenta"
                field="cuenta"
                options={options.cuenta}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              Gl. Desc.
            </div>
          </th>
          <th>
            <div className="borde-izq">
              Cargos
            </div>
          </th>
          <th>
            <div className="borde-izq">
              Abonos
            </div>
          </th>
          {mostrarTasa && (
            <th>
              <div className="borde-izq">
                <FiltroMultiple
                  label="Tasa"
                  field="tasa"
                  options={options.tasa}
                  filtros={filtros}
                  setFiltros={setFiltros}
                  filtrosTemp={filtrosTemp}
                  setFiltrosTemp={setFiltrosTemp}
                  mostrarFiltro={mostrarFiltro}
                  setMostrarFiltro={setMostrarFiltro}
                  actualizarPrioridad={actualizarPrioridad}
                  setPrioridadFiltros={setPrioridadFiltros}
                />
              </div>
            </th>
          )}
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Gl. Main"
                field="main"
                options={options.main}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq th-diferencia">
              <FiltroMultiple
                label="Fecha"
                field="fecha"
                options={options.fecha}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
              <button
                className="btn-order-diferencia"
                onClick={toggleOrdenFecha}
              >
                {ordenFecha === "asc" ? "↑" : ordenFecha === "desc" ? "↓" : "⇅"}
              </button>
            </div>
          </th>
          <th>
            <div className="borde-izq">
              Batch
            </div>
          </th>
          <th>
            <div className="borde-izq">Documento</div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Serie Fiscal"
                field="serie"
                options={options.serie}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              Folio fiscal
            </div>
          </th>
          <th>
            <div className="borde-izq">
              UUID
            </div>
          </th>
          {mostrarRelacionada && (
            <th>
              <div className="borde-izq th-diferencia">
                <FiltroMultiple
                  label="Relacionada"
                  field="relacion"
                  options={options.relacion}
                  filtros={filtros}
                  setFiltros={setFiltros}
                  filtrosTemp={filtrosTemp}
                  setFiltrosTemp={setFiltrosTemp}
                  mostrarFiltro={mostrarFiltro}
                  setMostrarFiltro={setMostrarFiltro}
                  actualizarPrioridad={actualizarPrioridad}
                  setPrioridadFiltros={setPrioridadFiltros}
                />
                <button
                  className="btn-order-diferencia"
                  onClick={toggleOrdenRelacionada}
                >
                  {ordenRelacionada === "asc" ? "↑" : ordenRelacionada === "desc" ? "↓" : "⇅"}
                </button>
              </div>
            </th>
          )}
          {mostrarRelacionada && (
            <th>
              <div className="borde-izq th-diferencia">
                Fecha de Aplicación
                <button className="btn-order-diferencia" onClick={toggleOrdenFechaAplicacion}>
                  {ordenFechaAplicacion === "asc" ? "↑" : ordenFechaAplicacion === "desc" ? "↓" : "⇅"}
                </button>
              </div>
            </th>
          )}
          <th>
            <div className="borde-izq th-diferencia">
              Fecha Cancelación
              <button className="btn-order-diferencia" onClick={toggleOrdenFechaCancelacion}>
                {ordenFechaCancelacion === "asc" ? "↑" : ordenFechaCancelacion === "desc" ? "↓" : "⇅"}
              </button>
            </div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Estado"
                field="estatus"
                options={options.estatus}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Tipo de Comprobante"
                field="comprobante"
                options={options.comprobante}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              RFC
            </div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Condicion de Pago"
                field="condicionPago"
                options={options.condicionPago}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              Desc.
            </div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Ref."
                field="ref"
                options={options.ref}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="Usuario"
                field="usuario"
                options={options.usuario}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
          <th>
            <div className="borde-izq">Orig. Invoice No.</div>
          </th>
          <th>
            <div className="borde-izq">Documento Refact.</div>
          </th>
          <th>
            <div className="borde-izq">
              <FiltroMultiple
                label="EQUIP"
                field="equip"
                options={options.equip}
                filtros={filtros}
                setFiltros={setFiltros}
                filtrosTemp={filtrosTemp}
                setFiltrosTemp={setFiltrosTemp}
                mostrarFiltro={mostrarFiltro}
                setMostrarFiltro={setMostrarFiltro}
                actualizarPrioridad={actualizarPrioridad}
                setPrioridadFiltros={setPrioridadFiltros}
              />
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {(datosFiltrados.length > 0 ? datosFiltrados : data).map((d) => (
          <tr>
            {/* <td className="ta-center">{d.origen}</td> */}
            <td className="ta-center">{capitalizePalabras(d.sucursal)}</td>
            <td className="ta-center">{capitalizePalabras(d.departamento)}</td>
            <td className="ta-center">{d.cuenta}</td>
            <td className="ta-left">{d.v_gl_desc}</td>
            <td className="ta-right">{FormatMoney(d.v_cargos)}</td>
            <td className="ta-right">{FormatMoney(d.v_abonos)}</td>
            {mostrarTasa && <td className="ta-center">{d.tasa}</td>}
            <td className="ta-left">{d.v_gl_main}</td>
            <td className="ta-center">
              {new Date(d.v_fecha).toLocaleDateString("es-MX", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </td>
            <td className="ta-center">{d.v_batch}</td>
            <td className="ta-center">{d.document_no}</td>
            <td className="ta-center">{d.serie}</td>
            <td className="ta-center">{d.folio}</td>
            <td className="ta-center">{d.uuid}</td>
            {mostrarRelacionada && <td className="ta-center">{d.v_relacion}</td>}
            {mostrarRelacionada && <td className="ta-center">{d.v_fecha_relacion
              ? new Date(d.v_fecha_relacion).toLocaleDateString("es-MX", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              : ""}</td>}
            <td className="ta-center">{d.fechacancelacion
              ? d.fechacancelacion
              : ""}</td>
            <td className="ta-center">{d.estatus}</td>
            <td className="ta-center">
              {capitalizePalabras(d.tipoComprobante)}
            </td>
            <td className="ta-center">{d.rfc}</td>
            <td className="ta-center">{capitalizePalabras(d.condicionPago)}</td>
            <td className="ta-left">{d.v_desc}</td>
            <td className="ta-center">{d.v_ref}</td>
            <td className="ta-center">{d.v_usuario}</td>
            <td className="ta-center">{d.orig_invoice_no}</td>
            <td className="ta-center">{d.document_refacturacion}</td>
            <td className="ta-center">{d.equip}</td>
          </tr>
        ))}
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

          <td className="ta-right">{FormatMoney(sumaCargos)}</td>
          <td className="ta-right">{FormatMoney(sumaAbonos)}</td>

          {mostrarTasa && <td></td>}
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          {mostrarRelacionada && <td></td>}
          {mostrarRelacionada && <td></td>}
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

          <td className="ta-right"></td>
          <td className="ta-right">{FormatMoney(sumaAbonos - sumaCargos)}</td>

          {mostrarTasa && <td></td>}
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          {mostrarRelacionada && <td></td>}
          {mostrarRelacionada && <td></td>}
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  );
};
